// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"151":"42379419","182":"e31a0e5d","765":"aa2920a9","926":"2246258e"}[chunkId] + ".css";
};